import api from '@pray/shared/utils/api';
import type { ListResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationFundResponse } from './types';

export async function getOrganizationFunds(organizationId: string) {
  const url = `/web/studio/organizations/${organizationId}/funds`;

  const response = await api.executeGetRequest<ListResponse<OrganizationFundResponse>>(url);

  return response;
}
